import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import { injectIntl } from 'react-intl'

import Partner from "../components/partner"
import Sponsor from "../components/sponsor"
import SponsorGold from "../components/sponsor-gold"
import SupportoMedia from "../components/supporto-media"
import { findLocalized } from '../utils'

const Banner = ({ intl: { locale }, iic }) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          allBannerYaml{
            edges{
              node{
                partner{
                  title
                  partners{
                    title
                    desc
                  }
                }
                sponsor{
                  title
                  sponsor{
                    title
                    desc
                  }
                }
                sponsor_gold{
                  title
                  sponsors{
                    title
                    desc
                  }
                }
                supporto_media{
                  title
                  sponsors{
                    title
                    desc
                  }
                }
                lang
              }
            }
          }
        }
      `}
      render={data => {
        const { partner, sponsor, sponsor_gold, supporto_media} = findLocalized(data.allBannerYaml, locale);
        return (
          <>
            <Sponsor iic={iic} data={sponsor}/>
            <SponsorGold iic={iic} data={sponsor_gold}/>
            <Partner iic={iic} data={partner}/>
            <SupportoMedia iic={iic} data={supporto_media}/>
          </>
        )
      }}
    />
  )
};

export default injectIntl(Banner);